<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 checklistTempTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="checklist_temp"
                        arrows >
                    <template slot="gofixTab:checklist_temp">
                        <gofix-card fullContent class="mb-0">
                            <gofix-default-table 
                                :settings="tableConfig"
                                :table-items="tableItems"
                                @new-item="modals.create.open = true"
                                @load-items="getTableData"
                                @row-click="clickToRowItem"
                                @import-items="importItems"
                                @delete-items="deleteItems"
                                @clone-master="modals.clone.open = true"
                                ref="gofixTable">
                            </gofix-default-table>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" @hidden="hideModelCreate" id="modal-Create"
                 :title="modals.create.data.id ? 'Edit ' + modals.create.data.name_checklist_templates : 'Create New Checklist Template'"
                 hide-footer :centered="true" v-model="modals.create.open">
            <b-form class="pb-20">
                <gofix-form-input label="Name" v-model="modals.create.data.name_checklist_templates"></gofix-form-input>
                <gofix-form-input label="Type" v-model="modals.create.data.type"></gofix-form-input>
            </b-form>
            <b-button-group class="d-block text-right">
                <!--<gofix-button label="MORE" @click="gotoItem" noBorder dark></gofix-button>-->
                <gofix-button label="APPLY"
                              @click="saveData"
                              :loading="modals.create.loading"
                              :disabled="$disabledCreateOrUpdate(modals.create.data, $accessModule.checklist_template)"
                              noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" @hidden="hideModelCreate" id="modal-Clone"
                 modal-class="default-modal"
                 title="Clone Master"
                 hide-footer :centered="true"
                 @shown="getMasterChecklist"
                 v-model="modals.clone.open">
            <b-form class="pb-20" v-if="modals.clone.list.length && !modals.clone.first">
                <ul class="listCheck list-unstyled listData">
                    <li>
                        <input class="styled-checkbox" type="checkbox" v-model="modals.clone.allSelect">
                        <label></label>
                        <span class="pl-25">Name</span>
                    </li>
                    <li v-for="(cl,index) in modals.clone.list" :key="index">
                        <input v-model="modals.clone.select" class="styled-checkbox" type="checkbox" :value="cl.id">
                        <label></label>
                        <span>{{index + 1}}</span>
                        <span>{{cl.name_checklist_templates}}</span>
                    </li>
                </ul>
            </b-form>
            <div class="pb-20 text-center" v-if="!modals.clone.list.length && !modals.clone.first">
                No Master!
            </div>
            <b-button-group class="d-block text-right pr-3">
                <gofix-button label="SUBMIT" @click="cloneDataFromMater" :loading="modals.clone.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import tabData from '@/data/_tabs';
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'checklist-template',
        components: {},
        data() {
            return {
                contract_tab: tabData.client_contract,
                tableConfig:{
                    name: 'client-contract-checklist-template',
                    controls:{
                        tableCloneMaster: true,
                        tableExport: false
                    },
                    filter: JSON.parse(JSON.stringify(filters['checklist_template'])),
                    page: 1,
                    limit: 100,
                    total: 0,
                },
                tableItems: [],
                modals:{
                    create : {
                        open: false,
                        loading: false,
                        data: {
                            id: null,
                            content_checklist_templates: null,
                            name_checklist_templates: '',
                            contract_id: this.$route.params.id,
                            is_master: false,
                            type: null
                        }
                    },
                    clone:{
                        open:false,
                        loading:false,
                        first:true,
                        allSelect:true,
                        list:[],
                        select:[]
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            }),
        },
        watch: {
            ClientContractID: function(val, old) {
                if (!val) {
                    return this.$router.push(`/v2/contract-client`)
                }
                // if (val && old && val.id != old.id) {
                //     this.tableConfig.filter.contract_id.value = val.id,
                //     this.$refs.gofixTable.reloadTableKeepFilter();
                // }
            },
            "modals.clone.allSelect": function(val) {
                if (val) {
                    this.modals.clone.select = [];
                    for (let i in this.modals.clone.list) {
                        this.modals.clone.select.push(this.modals.clone.list[i].id)
                    }
                }
                if(!val && this.modals.clone.list.length == this.modals.clone.select.length) {
                    this.modals.clone.select = [];
                }
            },
            "modals.clone.select": function(val) {
                if(this.modals.clone.select.length > 0 && this.modals.clone.list.length === this.modals.clone.select.length) {
                    this.modals.clone.allSelect = true;
                }else{
                    this.modals.clone.allSelect = false;
                }
            }
        },
        created() {},
        methods: {
            /*-- Table callback --------*/
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                if(!tableRequest.filter.contract_id.value) {
                    this.tableItems = [];
                    this.tableConfig.total = 0;
                    resolve({ items: [], total: 0 });
                    return;
                }
                await this.$store.dispatch("v2CheckListTemplateController/getListCheckListTemplate", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.items;
                        this.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load the checklist", "danger");
                        reject();
                    })
            },
            async clickToRowItem(item){
                this.modals.create.data = Object.assign({}, item);
                this.$store.commit('v2CheckListTemplateController/setTemplate', item);
                this.gotoItem();
            },
            async importItems(callback){
                const { file, resolve, reject } = await callback();
                await this.$store.dispatch(`v2CheckListTemplateController/uploadFileChecklistTemplate`, {
                    fileChecklistTemplate: file,
                    contract_id : this.$route.params.id
                })
                    .then(response => {
                        let variant = 'success';
                        let msg = this.$notificationV2('importing', 'checklist_template');
                        let result = response.data.data;
                        if(result.data && result.data.count && result.data.count.failed ) {
                            variant = 'danger';
                            msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                        }

                        this.$alertNotification(msg, variant);

                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                await this.$store.dispatch('v2CheckListTemplateController/deleteTemplate', ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'checklist_template'))
                    })
                    .catch(err => {
                        reject();
                    })
            },
            saveData(){
                //check loading and required
                if(this.modals.create.loading) return;
                if(!this.modals.create.data.name_checklist_templates){
                    this.$alertNotification("The 'Name' field is required", "danger");
                    return;
                }
                this.modals.create.loading = true;
                this.$store.dispatch(`v2CheckListTemplateController/createTemplate`, this.modals.create.data)
                    .then(response => {
                        this.modals.create.loading = false;
                        this.modals.create.open = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        return this.$alertNotification(this.$notificationV2('editing', 'checklist_template'));
                    })
                    .catch(err => {
                        this.modals.create.loading = false;
                        if(err.response) {
                            let msg = "Can't create checklist template!";
                            return this.$alertNotification(msg, "danger");
                        }
                    })
            },
            //Reset create modal
            hideModelCreate(){
                this.modals.create.data = {
                    id: null,
                    content_checklist_templates: null,
                    name_checklist_templates: '',
                    contract_id: this.$route.params.id,
                    is_master: false,
                }
            },
            //Go to detail page
            gotoItem() {
                if(this.modals.create.data.id != null) {
                    return this.$router.push(`/v2/contract-client/${this.$route.params.id}/checkList-template/${this.modals.create.data.id}`)
                }
                this.$store.commit('v2CheckListTemplateController/setTemplate', {
                    id: null,
                    name_checklist_templates: this.modals.create.data.name_checklist_templates,
                    content_checklist_templates: [],
                    contract_id: this.$route.params.id,
                    is_master: false
                });
                this.$router.push(`/v2/contract-client/${this.$route.params.id}/checkList-template/add`)
            },
            //GET master checklist template
            getMasterChecklist(){
                this.$store.dispatch("v2CheckListTemplateController/getMasterChecklist")
                    .then(response => {
                        this.modals.clone.list = response.data.data.items;
                        this.modals.clone.select = [];
                        this.modals.clone.first = false;
                    })
                    .catch(err => {
                        this.modals.clone.list = [];
                        this.modals.clone.select = [];
                        this.modals.clone.first = false;
                    })
            },
            cloneDataFromMater(){
                this.modals.clone.loading = true;
                let data = {
                    contract_id: this.$route.params.id,
                    ids: this.modals.clone.select
                };
                this.$store.dispatch("v2CheckListTemplateController/cloneTemplate",data)
                    .then(response => {
                        this.$alertNotification("Successfully Clone");
                        this.modals.clone.open = false;
                        this.modals.clone.loading = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                    })
                    .catch(err => {
                        this.$alertNotification("Clone failed!", "danger");
                        this.modals.clone.loading = false;
                    })
            }

        }
    }
</script>